// 获取基础配置
export const isDev = process.env.NODE_ENV === 'development';

// baseURL 允许通过环境变量 REACT_APP_BASE_URL 设置
export const baseURL =
  process.env.REACT_APP_BASE_URL || (isDev ? '/sqx_fast' : '/api');

// wsURL 允许通过环境变量 REACT_APP_WS_URL 设置
export const wsURL =
  process.env.REACT_APP_WS_URL ||
  (isDev
    ? 'ws://admin.billiontest.live/wss'
    : `wss://${window.location.hostname}/wss`);
